/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { closeBrowserLoading, printNativeMethodFallback, showBrowserLoading, showBrowserToast } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { NativeDialogOptions } from '../../types';

/**
 * 打开原生toast弹框
 * @param message
 */
export const nativeToast = (message: string): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    showBrowserToast(message);
    return;
  }
  const data: {
    msg: string;
  } = {
    msg: message,
  };
  const params: string = JSON.stringify(data);
  bridgeCallHandler('nativeToast', params, null);
};

/**
 * 关闭客户回访问弹框
 */
export const answerDialogDismiss = (): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('answerDialogDismiss', 'answerDialogDismiss');
    return;
  }

  bridgeCallHandler('answerDialogDismiss', '', null);
};

/*
 * 显示原生dialog
 */
export const showNativeDialog = (data: NativeDialogOptions, callback: (data: any) => {}): void => {
  if (!isInApp()) {
    printNativeMethodFallback('showNativeDialog', 'showNativeDialog');
    return;
  }
  bridgeCallHandler('showNativeDialog', JSON.stringify(data), callback);
};

/**
 * 全屏loading
 */
export const showLoadingDialog = (value: string): void => {
  if (!isInApp()) {
    showBrowserLoading(value);
    return;
  }
  bridgeCallHandler('showLoadingDialog', value, null);
};

/**
 * 关闭全屏loading
 */
export const closeLoadingDialog = (): void => {
  if (!isInApp()) {
    closeBrowserLoading();
    return;
  }
  bridgeCallHandler('closeLoadingDialog', '', null);
};

/**
 * 设置页面高度
 */
export const setPageHeight = (value: string): void => {
  if (!isInApp()) {
    printNativeMethodFallback('setPageHeight', 'setPageHeight');
    return;
  }
  bridgeCallHandler('setPageHeight', value, null);
};
